import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar/NavBar';
import { BackIcon } from '../assets/icons/icons';
import Write from '../components/Write/Write';
import './train-mind.css';

export default function TrainMindPage() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('write');

  return (
    <>
      <NavBar />
      <main className="web-view">
        <div className="trainmind-container">
          <div className="trainmind-header">
            <BackIcon className="back-icon" onClick={() => navigate('/')} />
            <h1>Train Your Mind</h1>
          </div>
          <p className="trainmind-subtitle">
            Strengthen your mindset with reflective journaling. This will help improve focus, reduce stress, and build
            discipline that supports your fitness goals.
          </p>
          <div className="trainmind-subnav">
            <button
              className={`subnav-item ${tab === 'write' ? 'active' : ''}`}
              onClick={() => setTab('write')}
            >
              Write
            </button>
            <button
              className={`subnav-item ${tab === 'entries' ? 'active' : ''}`}
              onClick={() => navigate('/train-mind/entries')}
            >
              Old Entries
            </button>
          </div>
          {tab === 'write' && (
            <div className="trainmind-content">
              <Write />
            </div>
          )}
        </div>
      </main>
    </>
  );
}
